import React, { useState } from 'react';
import './Navigation.scss';
import Categories from '../Categories/Categories';

function Navigation(props) {
  const getLentgh = (category) => {
    if (props.selectedItems[category])
      return props.selectedItems[category].length;
    return 0;
  }

  const handleSetCategory = (i) =>{
    debugger;
    props.setCategory(i);
  }
  return (
    <div className="navigation-container">
     
      <div className="categories-container">
        {
          props.categories.map((item, i) => (
            <Categories
              ended={getLentgh(item.category) === 3}
              setCategory={() => handleSetCategory(i)}
              selected={getLentgh(item.category)}
              title={item.title}
              category={item.category}
              currentCategory={props.currentCategory}
              index={i}
              previewCategoryEnded={i > 0 ? getLentgh(props.categories[i - 1].category) === 3 : false}
              getLentgh={getLentgh}
              currentCategoryEnded={getLentgh(props.currentCategory) === 3}
              categoryIndex={props.categoryIndex}
            />
          ))
        }
        <div className={`timeline ${props.currentCategory} ${props.isResultsDisplay ? "end" : ""}`}></div>

      </div>
    </div>
  );
}

export default Navigation;
